import { INITIAL_SAVE_REQUEST_META } from '../utils';
import { PromotionalBannersWidgetData } from './types';

const defaultPromotionalBannersWidgetData: NonNullable<
  PromotionalBannersWidgetData['initialData']
> = {
  deviationPageBanner: false,
  profileCoverBanner: false,
};

export const defaultPromotionalBannersWidgetState: PromotionalBannersWidgetData = {
  initialData: defaultPromotionalBannersWidgetData,
  currentData: defaultPromotionalBannersWidgetData,
  isDirty: false,
  saveRequest: INITIAL_SAVE_REQUEST_META,
};
